module.exports = {
    AUTH_ERROR :{
        ALREADY_REGISTERED_JS : "You are already registered as Jobseeker. Please login with different number or email" ,
        ALREADY_REGISTERED_EMP : "You are already registered as Employer. Please login with different number" ,
        ALREADY_REGISTERED_SOCIAL_EMP : "You are already registered as Employer. Please login with different credentials",
        ALREADY_REGISTERED_SOCIAL_JS : "You are already registered as JobSeeker. Please login with different credentials",
    }
}